export default __webpack_public_path__ + "static/media/bin.72ff0c88.png";